module.exports = __webpack_public_path__ + "75ff7a06dea6944aaee0c6bd2789a122.pdf";